import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

import AOS from "aos";
import VueTypedJs from "vue-typed-js/dist/vue-typed-js.browser";
import VModal from "vue-js-modal/dist/index.nocss.js";
import CoolLightBox from "vue-cool-lightbox";

import "./assets/style.css";
import "aos/dist/aos.css";
import "vue-typed-js/dist/vue-typed-js.css";
import "boxicons/css/boxicons.min.css";
import "@icon/icofont/icofont.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-js-modal/dist/styles.css";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

Vue.config.productionTip = false;
Vue.use(VueTypedJs);
Vue.use(CoolLightBox);
Vue.use(VModal, {
  dynamicDefaults: {
    draggable: false,
    resizable: true,
    height: "100%",
    scrollable: true
  }
});

new Vue({
  created() {
    AOS.init({ disable: "phone" });
  },
  router,
  render: h => h(App)
}).$mount("#app");
